import { FC } from "react";
import S from "./winners-footer.styled";
import { CustomModalTypes } from "../../../../utils/types/custom-modal";

const DrawWinnersFooter: FC<CustomModalTypes.Footer> = ({ children }) => {
  return <S.FooterContainer>{children}</S.FooterContainer>;
};

export default DrawWinnersFooter;
